// extracted by mini-css-extract-plugin
module.exports = {"number-input-price":"number-input-price-91e684d564dc1ba49818335085af73de","sample-form-message-table":"sample-form-message-table-366fd0dfa5400a813758a755d355a368"};